<template>
  <LsModal title="Turn Down Quote" track-id="instant_quote_turn_down_modal">
    <template #body>
      <div>
        <LsInput
          v-model="notes"
          track-id="instant_quote_turn_down_modal-notes"
          name="notes"
          label="What is the reason for rejecting the quote?"
          placeholder="Additional details..."
          type="textarea"
        />
      </div>
    </template>
    <template #footer>
      <LsButton
        text="Turn Down"
        track-id="instant_quote_turn_down_modal-turn_down"
        test-id="turn_down"
        :loading="isLoading"
        @click="turnDown"
      />
    </template>
  </LsModal>
</template>

<script>
import { LsModal, LsButton, LsInput } from '@/components/common';
import { mapActions, mapState } from 'vuex';
import {
  INSTANT_QUOTE__REJECT_QUOTE,
  INSTANT_QUOTE__RESET_QUOTE,
  ONBOARDING__REJECT_INSTANT_QUOTE,
} from '@/store/types';
import VueTypes from 'vue-types';
import { lsValidationService } from 'ls-vue-common';
import _ from 'lodash';

export default {
  name: 'InstantQuoteTurnDownModal',
  $_veeValidate: {
    validator: 'new',
  },
  components: {
    LsModal,
    LsButton,
    LsInput,
  },
  props: {
    // eslint-disable-next-line vue/prop-name-casing
    property_id: VueTypes.string.def(_.constant(null)),
    currentInstantQuoteId: VueTypes.number.def(_.constant(null)),
  },
  data() {
    return {
      //form
      acceptable_price: 0,
      notes: '',
    };
  },
  computed: {
    ...mapState(['instantQuote', 'onboarding']),
    isLoading() {
      return this.instantQuote.loadingStatus.isUpdating || this.onboarding.loadingStatus.isRemoving;
    },
  },
  methods: {
    ...mapActions([
      INSTANT_QUOTE__REJECT_QUOTE,
      INSTANT_QUOTE__RESET_QUOTE,
      ONBOARDING__REJECT_INSTANT_QUOTE,
    ]),
    async turnDown() {
      const valid = await this.$validator.validateAll();
      if (!valid) {
        return lsValidationService.scrollToInvalid();
      }
      if (this.currentInstantQuoteId) {
        this.ONBOARDING__REJECT_INSTANT_QUOTE({
          instantQuoteId: this.currentInstantQuoteId,
          formData: {
            acceptable_price: this.acceptable_price,
            notes: this.notes,
          },
          onSuccess: () => {
            this.$parent.close();
          },
        });
      } else {
        this.INSTANT_QUOTE__REJECT_QUOTE({
          property_id: this.property_id,
          formData: {
            acceptable_price: this.acceptable_price,
            notes: this.notes,
          },
          onSuccess: this.onSuccess,
        });
      }
    },
    onSuccess() {
      this.INSTANT_QUOTE__RESET_QUOTE();
      this.$parent.close();
      this.$router.push({
        name: 'services',
      });
    },
  },
};
</script>
